// 登录注册
const registrationLogin = () => import('@/pages/login/registrationLogin.vue');
// 密码登录
const passwordLogin = () => import('@/pages/login/passwordLogin.vue');
// 重置密码
const resetPassword = () => import('@/pages/login/resetPassword.vue');
// 手机号一键登录
const phoneLogin = () => import('@/pages/login/phoneLogin.vue');
// 找回密码
const retrievePassword = () => import('@/pages/login/retrievePassword.vue');
// 綁定手機號
const bindPhoneNum = () => import('@/pages/login/bindPhoneNum.vue');
// 获取验证码
const getCode = () => import('@/pages/login/getCode.vue');
// 极光一键登录
const quickLogin = () => import('@/pages/login/quickLogin.vue');

export default [
  {
    path: '/registrationLogin',
    name: 'registrationLogin',
    component: registrationLogin,
    meta: {
      title: '登录',
      keepAlive: false,
    },
  },
  {
    path: '/passwordLogin',
    name: 'passwordLogin',
    component: passwordLogin,
    meta: {
      title: '登录',
    },
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: resetPassword,
    meta: {
      title: '重置密码',
    },
  },
  {
    path: '/phoneLogin',
    name: 'phoneLogin',
    component: phoneLogin,
    meta: {
      title: '一键登录',
    },
  },
  {
    path: '/retrievePassword',
    name: 'retrievePassword',
    component: retrievePassword,
    meta: {
      title: '找回密码',
    },
  },
  {
    path: '/bindPhoneNum',
    name: 'bindPhoneNum',
    component: bindPhoneNum,
    meta: {
      title: '找回手机号',
    },
  },
  {
    path: '/getCode',
    name: 'getCode',
    component: getCode,
    meta: {
      title: '获取验证码',
    },
    beforeRouteLeave(to, from, next) {
      // if (answer) {
      //   next();
      // } else {
      next(false);
      // }
    },
  },
  {
    path: '/quickLogin',
    name: 'quickLogin',
    component: quickLogin,
    meta: {
      title: '一键登录',
    },
  },
];
